import { fetchMPSupplierCountries, mpselectSupplierCountries, mpselectSupplierTypes } from "@/store/modern/slices/countrySlice";
import Emitter from "@/utils/Emitter";
import { filter, indexOf, join, lowerCase, map, split } from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const SideFilter = ({ filterObj }) => {

    const dispatch = useDispatch();
    const countries = useSelector(mpselectSupplierCountries);
    const business_types = useSelector(mpselectSupplierTypes);
    const [activeIndex, setActiveIndex] = useState([0, 1]);

    const data = [
        {
            title: "Business Type",
            content: (
                <>
                    <ul>
                        {
                            business_types && map(business_types, (val) => {
                                return (<li>
                                    <span onClick={() => handleFilterClick("business_type", val)}>
                                        {val}
                                    </span>
                                </li>)
                            })
                        }
                    </ul>
                </>
            ),
        },
        {
            title: "Supplier Country",
            content: (
                <>
                    <ul className="supplier-country-list">
                        {
                            map(countries, (country) => {
                                return (<li>
                                    {/* <Link to="" title={country.name} onClick={() => handleFilterClick("country", country.id)}> */}
                                    <div className="link" onClick={() => handleFilterClick("country", country)}>
                                        {/* <i className="flag"></i> */}
                                        <img
                                            style={{ height: 24, width: 24 }}
                                            //src={`${flagUrl}/${val?.country?.iso3}.svg`}
                                            src={require(`@/assets/images/svg/flag/${lowerCase(country?.iso3)}.svg`)}
                                            alt={country?.iso3}

                                            className="squre-icon"
                                        />
                                        <span>{country.name}</span>
                                    </div>

                                    {/* </Link> */}
                                </li>)
                            })
                        }
                    </ul>
                </>
            ),
        },
    ];

    const toggleItem = (index) => {
        let existingIndex = [...activeIndex];
        if (indexOf(existingIndex, index) !== -1) {
            let eIndx = filter(existingIndex, (val) => val !== index);
            setActiveIndex(eIndx);
        } else {
            setActiveIndex((prev) => {
                return [...prev, index]
            });
        }
    };

    const handleFilterClick = (type, val) => {
        let fObj = { ...filterObj };
        fObj.filterKeys = [...filterObj.filterKeys];

        if (type === "business_type") {
            let bType = split(fObj.business_type, ",").filter(Boolean);

            // ✅ Skip if already exists
            if (bType.includes(val)) return;

            let fKey = { label: val, type: "business_type" };
            bType.push(val);

            fObj.business_type = join(bType, ",");
            fObj.filterKeys = [...fObj.filterKeys, fKey];
            fObj.offset = 0;

            Emitter.emit("SET_MP_SUPPLIER_FILER", fObj);
        }

        if (type === "country") {
            let cnty = split(fObj.supplier_country, ",").filter(Boolean);

            // ✅ Skip if already exists
            if (cnty.includes(String(val.id))) return;

            let fKey = { label: val.name, type: "supplier_country", id: String(val.id), };
            cnty.push(val.id);

            fObj.supplier_country = join(cnty, ",");
            fObj.filterKeys = [...fObj.filterKeys, fKey];
            fObj.offset = 0;

            Emitter.emit("SET_MP_SUPPLIER_FILER", fObj);
        }
    }

    useEffect(() => {
        dispatch(fetchMPSupplierCountries());
    }, [filterObj]);

    return (
        <div className='side-filter'>
            {/* accordion wrape START */}
            <div className="accordion-wrape">
                <div className="accordion">
                    {data.map((item, index) => (
                        <article
                            key={`f_${index}`}
                            className={`accordion-item ${(indexOf(activeIndex, index) !== -1) ? "active" : ""
                                }`}
                        >
                            <button
                                className="accordion-header"
                                onClick={() => toggleItem(index)}
                                key={`fs_${index}`}
                            >
                                <span>{item.title}</span>

                                <div className="icon-circle">
                                    {(indexOf(activeIndex, index) !== -1) ? "" : ""}
                                </div>
                            </button>

                            <div className="accordion-content" key={`fsd_${index}`}>
                                {(indexOf(activeIndex, index) !== -1) && <div className="inner" >{item.content}</div>}
                            </div>
                        </article>
                    ))}
                </div>
            </div>
            {/* accordion wrape END */}
        </div>
    )
}

export default SideFilter;